const editAccount = () => {
  const formElement = document.querySelector('.woocommerce-EditAccountForm');
  if (!formElement) return;
  const switchButton = document.getElementById('view-switch');
  if (!switchButton) return;

  jQuery('body').on('click', '.scroll-to-newsletter', function(e) {
    e.preventDefault();

    jQuery('html, body').animate({
      scrollTop: jQuery(".footer-newsletter").offset().top - 100
    }, 1000);

    jQuery('.mc4wp-form input[type="email"]').focus();
  });

  /**
   * Met à jour le contenu du formulaire
   */
  const updateView = () => formElement.classList.toggle('edition-mode');

  /**
   * Met à jour le contenu du dataset "view"
   * du bouton.
   */
  const switchView = () => {
    // On modifie le prochain fonctionnement (cible)
    // du bouton au clic et on modifie le contenu
    // texte du bouton
    if (switchButton.dataset.view === 'edit') {
      switchButton.dataset.view = 'view';
      switchButton.innerText = 'Annuler les modifications';
    } else {
      switchButton.dataset.view = 'edit';
      switchButton.innerText = 'Modifier';
    }

    // On change l'apparence du bouton pour le
    // griser
    switchButton.classList.toggle('btn');

    // On modifie le contenu du formulaire
    updateView();
  };

  const init = () => {
    switchButton.addEventListener('click', switchView);
  };

  init();
};

export default editAccount;
